import React, { useState } from 'react';
import { connect } from 'react-redux'
import UserService from "../api/UserService"
import { openSnackbar } from "../actions/snackbar"

function UserRestorePassword({ openSnackbar }) {
  const [submitted, setSubmitted] = useState(false);
  const [login, setLogin] = useState("");

  if (!submitted) {
    return (
      <form className='auth-restorePasswordForm' onSubmit={SubmitRestorePassword}>
        <label style={{ textAlign: 'left', paddingLeft: '24px' }} className="auth-label clr-white fs-14">Введите Ваш e-mail:</label>
        <input className="auth-input small" type="text" onChange={e => setLogin(e.target.value)} value={login} placeholder="Указанный при регистрации" />
        <button className="auth-button mt-16" type="submit">Восстановить</button>
      </form>
    )
  } else {
    return (
      <div className="auth-restorePasswordForm">
        <p className='auth-label clr-white fs-14'>Ссылка для восстановления <br /> пароля отправлена на указанный <br /> e-mail! </p>
      </div>
    )
  }

  function SubmitRestorePassword(e) {
    e.preventDefault();
    if (login) {
      UserService.restorePassword(login).then(response => {
        if (response.data.ok) {
          setSubmitted(true)
        } else openSnackbar(`Произошла ошибка во время восстановления пароля: ${response.data.error}`, "error")
      }).catch(() => openSnackbar("Ошибка сети", "error"))
    } else {
      openSnackbar("Необходимо ввести логин или e-mail", "error")
    }
  }
}

export default connect(null, { openSnackbar })(UserRestorePassword)